<img id="logo" ngSrc="assets/img/ogi-logo.png" width="200" height="51" alt="OGI Logo" priority />
<div id="page">
  <div id="container">
    <h4>Forgot Password</h4>
    <form [formGroup]="resetForm" (ngSubmit)="onSubmit()">
      <app-mat-form-field
        iconName="email"
        [field]="emailField"
        [parentForm]="resetForm"
      >
      </app-mat-form-field>
      <span class="body2 error" aria-live="polite">
        @if (requestError()) {
          <span>Error: </span>
          {{ requestError()!.message }}
        }
      </span>
      <div id="button--container">
        <app-button
          buttonType="submit"
          buttonStyle="standard"
          label="Submit"
          buttonId="Submit"
          [isDisabled]="resetForm.invalid"
          [isProcessing]="isProcessing()"
        >
        </app-button>
      </div>
      <a [routerLink]="'/login'" class="button-styling">Return to login</a>
    </form>
  </div>
</div>
